import Vue from 'vue';
import { sortBy } from '../../../helpers/helpers';

const state = {
  sites: [],
  weather: [],
  forecast: [],
  selectedSite: null
};

const getters = {
  getSiteNames(state) {
    if (state.sites.length === 0) {
      return [];
    }
    return state.sites
      .map((a) => {
        const obj = {
          name: a.name,
          id: a.id,
          angle: a.rotation_angle
        };
        return obj;
      })
      .sort(sortBy('name'));
  },
  getSelectedSite(state) {
    return state.selectedSite;
  }
};

const mutations = {
  setSites(state, siteData) {
    state.sites = siteData;
  },
  setWeather(state, weatherData) {
    const { resource } = weatherData;
    const site = state.sites.find(a => a.id === weatherData.site.id);
    Vue.set(site, resource, weatherData.data);
  },
  setSelectedSite(state, site) {
    state.selectedSite = site;
  }
};

const actions = {
  async getSites({ state, commit, dispatch }) {
    if (state.sites.length === 0) {
      const { sites } = await this.$api.get('/v1/sites');
      commit('setSites', sites);
      dispatch('getOpenWeatherMapData', 'weather');
      dispatch('getOpenWeatherMapData', 'forecast');
    }
  },
  async getOpenWeatherMapData({ state, commit }, resource) {
    (await Promise.all(state.sites
      // eslint-disable-next-line consistent-return
      .map(async (site) => {
        if (site.latitude && site.longitude) {
          const data = await this.$wapi.get(`/2.5/${resource}`, {
            query: {
              lat: site.latitude,
              lon: site.longitude,
              units: 'metric'
            }
          });
          data.site = site;
          return {
            data,
            site,
            resource
          };
        }
      }))
    ).filter(wd => wd != null)
      .forEach(weatherData => commit('setWeather', weatherData));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
